import { React, useEffect, useState } from 'react'
import axios from 'axios'
import {Table, Checkbox, Button } from 'flowbite-react'
import LoadingSpinner from '../../components/LoadingSpinner';

const SolutionsList = ({onClose,userId,users, setUsers}) => {
    const [Solutions, setSolutions] = useState([]);
    const [Error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isChangeStatus, setChangeStatus] = useState(false);


    const handleChange = async (id,checked) => {
        setIsLoading(true);

        
        setSolutions((prevSolutions) =>
            prevSolutions.map((sol) =>
                sol.id === id
            ? { ...sol, checked: !sol.checked } 
            : sol
            )
        );
        console.log(`id:${id} checked: ${!checked}`);
        try {
            const response = await axios.post( 
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/usersolution/${userId}/findorcreate`,
                {
                    solutionid: id
                },
                {
                    withCredentials: true,
                }
            );
        } catch (error) {
            setError(error.message);
        } finally{
            setIsLoading(false);
            setChangeStatus(true);
            //setUsers(users);
        } 
        
        
    };

    useEffect(()=>{
        const getSolutionByUser = async () => {
            console.log("entraSolutionByUser");
            setIsLoading(true);
            try {
                const response = await axios.get( 
                    `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/usersolution/${userId}`,
                    {
                        withCredentials: true,
                    }
                );

                if (response.statusText !== "OK") {
                    throw new Error(response.message || 'Error en la obtención de datos');
                }

                setSolutions(response.data.solutions);
            } catch (error) {
                setError(error.message);
            } finally{
                setIsLoading(false);
            } 
        }
        getSolutionByUser();

        console.log("status",isChangeStatus);
        if(isChangeStatus){
            console.log("actualizaSoluciones");
        }
    },[isChangeStatus]);

  return (
    <>
        {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
        <div className="overflow-x-auto">
        <Table hoverable>
            <Table.Head>
            <Table.HeadCell className="p-4">
                <Checkbox />
            </Table.HeadCell>
            <Table.HeadCell>Solución</Table.HeadCell>
            </Table.Head>
            <Table.Body className="divide-y">
                {Solutions.map((sol) => (
                    <Table.Row key={sol.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                        <Table.Cell className="p-4">
                        <Checkbox 
                            key={sol.id}
                            name="checkSolution"
                            className="SolutionsCheck"
                            onChange={()=>handleChange(sol.id, sol.checked)} 
                            checked={sol.checked}
                            />
                        </Table.Cell>
                        <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                            {sol.name}
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
        </div>
    </>
  )
}

export default SolutionsList